import classNames from 'classnames';
import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  laptopAndAbove,
  laptopAndBelow,
} from '@sorare/core/src/style/mediaQuery';

import { BenchObjectTableFirstCell } from 'components/benchObject/BenchObjectTable/ui';

const PlayerGeneral = styled(Horizontal)`
  padding: var(--unit) 0;
  background-color: var(--current-row-color);
  z-index: 1;
  width: var(--player-metas-width);

  @media ${laptopAndAbove} {
    gap: var(--double-unit);
    padding: var(--double-unit) 0;
  }
`;
const PlayerMetas = styled(Vertical)`
  width: 100%;
`;
const AvatarSkeleton = styled(Skeleton)`
  flex-shrink: 0;

  &.SCOUTING {
    width: var(--quadruple-unit);
    height: var(--quadruple-unit);
    border-radius: 50%;

    @media ${laptopAndAbove} {
      border-radius: 0;
      width: calc(10 * var(--unit));
      height: calc(10 * var(--unit));
    }
  }

  &.COMPOSE {
    width: calc(6 * var(--unit));
    height: calc(6 * var(--unit));
    border-radius: 3em;
  }
`;
const PlayerNameSkeleton = styled(Skeleton)`
  width: 100%;
  height: var(--intermediate-unit);
  @media ${laptopAndAbove} {
    height: var(--double-unit);
  }
`;
const PlayerClubSkeleton = styled(Skeleton)`
  width: 50%;
  height: var(--double-and-a-half-unit);
`;

const StatIcon = styled(Vertical)`
  width: var(--player-stats-icon-width);
  @media ${laptopAndBelow} {
    display: none;
  }
`;
const StatIconSkeleton = styled(Skeleton)`
  width: var(--quadruple-unit);
  height: var(--triple-unit);
`;

const ButtonSkeleton = styled(Skeleton)`
  flex-shrink: 0;
  width: var(--triple-unit);
  height: var(--triple-unit);
  border-radius: var(--triple-unit);
  @media ${laptopAndAbove} {
    display: none;
  }
`;

type Props = {
  variant?: 'COMPOSE' | 'SCOUTING';
};

export const FirstCellSkeleton = ({ variant }: Props) => {
  return (
    <BenchObjectTableFirstCell>
      <PlayerGeneral gap={1}>
        <AvatarSkeleton className={classNames(variant)} />
        <PlayerMetas gap={0.5}>
          <PlayerNameSkeleton />
          <PlayerClubSkeleton />
        </PlayerMetas>
      </PlayerGeneral>
      <StatIcon>
        <StatIconSkeleton />
      </StatIcon>
      <ButtonSkeleton />
    </BenchObjectTableFirstCell>
  );
};
